import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Toolbar,
  AppBar as MaterialAppBar,
  IconButton,
} from '@material-ui/core';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { AccountCircle } from '@material-ui/icons';

import { logout } from '../../store/actions/user.action';
import Logo from '../shared/logo';
// import { openPasswordModal } from '../../store/actions/app.action';

const AppBar = () => {
  const email = useSelector((state) => state.user.isAuth);
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);


  const handleLogout = () => {
    dispatch(logout());

    handleClose();
  };

  const handleOpen = (e) => setIsOpen(e.currentTarget);
  const handleClose = () => setIsOpen(false);

  return (
    <MaterialAppBar position="fixed">
      <Toolbar style={{ justifyContent: 'center' }}>
        <Logo />

        <div style={{ position: 'absolute', right: 10 }}>
          <IconButton onClick={handleOpen}>
            <AccountCircle style={{ color: '#FFF' }} />
          </IconButton>
          {/* <Button onClick={handleOpen}>
            <Typography style={{color: '#fff'}}>{email}</Typography>
          </Button> */}
          <Menu anchorEl={isOpen} open={!!isOpen} onClose={handleClose}>
            <MenuItem key={'nav_bar_profile_email'} onClick={handleClose}>
              {email}
            </MenuItem>
            {/* <MenuItem onClick={handlePassword}>Change password</MenuItem> */}
            <MenuItem key={'nav_bar_profile_logout'} onClick={handleLogout}>
              Logout
            </MenuItem>
          </Menu>
        </div>
      </Toolbar>
    </MaterialAppBar>
  );
};
export default AppBar;
